import BaseAPI, { querySuffix } from "./BaseAPI";
import { reportRoute } from "../routes";

export default class ReportAPI extends BaseAPI {
    constructor(emitterInstance) {
        super(emitterInstance, reportRoute, "report");
    }

    async Counts({ signal } = {}) {
        return this._request("get", this._url("/counts"), null, { signal });
    }

    async ProductionRuns(params = {}) {
        return this._request("get", this._url(`/production-runs${querySuffix(params)}`));
    }

    async DailyDashboard(params = {}) {
        return this._request("get", this._url(`/daily-dashboard${querySuffix(params)}`));
    }
}
